import * as Lucide from "lucide-react";

// Convert "trending-up" -> "TrendingUp"
function toPascal(name) {
    return name.replace(/(^|-)(.)/g, (_, _dash, c) => (c || "").toUpperCase());
}

export function getLucideIcon(name, fallback = "Sparkles") {
    if (!name) return Lucide[fallback] || Lucide.Sparkles;
    const pascal = toPascal(name.trim());
    return Lucide[pascal] || Lucide[fallback] || Lucide.Sparkles;
}
